import { GeneratedImageToolResult } from 'libs/gb-dashboard/shared/data-access-ai/src/lib/+state/ai.models'
import * as AiActions from 'libs/gb-dashboard/shared/data-access-ai/src/lib/+state/ai.actions'
import * as SelectedAuctionActions from 'libs/gb-dashboard/auctions/data-access-selected-auction/src/lib/+state/selected-auction.actions'
import { ToolHandler, ToolApplyContext } from '../tool-handler.interface'
import { ToolConfig, SetupGuideAiMessage } from '../../types/ai-chat.types'
import { AiImageCache } from '../../utils/ai-image-cache.util'

export class GenerateImageHandler implements ToolHandler {
  name = 'generate_image'

  constructor(private imageCache: AiImageCache) {}
  configs: ToolConfig[] = [
    {
      labelKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_LOGO.LABEL',
      generatingKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_LOGO.GENERATING',
      resultKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_LOGO.RESULT',
      displayType: 'image',
      dashboardPage: 'branding',
    },
    {
      labelKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_BANNER.LABEL',
      generatingKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_BANNER.GENERATING',
      resultKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_BANNER.RESULT',
      displayType: 'image',
      dashboardPage: 'branding',
    },
  ]

  config: ToolConfig = this.configs[0]

  readonly toolNames: string[] = ['generate_logo', 'generate_banner']

  matches(toolName: string): boolean {
    return this.toolNames.includes(toolName)
  }

  getConfigForTool(toolName: string): ToolConfig {
    return toolName === 'generate_banner' ? this.configs[1] : this.configs[0]
  }

  getPreviewData(message: SetupGuideAiMessage): string {
    if (!message.toolContent) {
      return ''
    }
    const imageResult = message.toolContent as GeneratedImageToolResult
    if (imageResult.imageKey) {
      return this.imageCache.getImageUrl(imageResult.imageKey)
    }
    if (imageResult.base64_image) {
      return `data:image/png;base64,${imageResult.base64_image}`
    }
    return ''
  }

  canApply(message: SetupGuideAiMessage): boolean {
    if (!message.toolContent) {
      return false
    }
    const imageResult = message.toolContent as GeneratedImageToolResult
    return !!imageResult.generated_image
  }

  apply(message: SetupGuideAiMessage, context: ToolApplyContext): void {
    if (!message.toolContent) {
      return
    }
    const imageResult = message.toolContent as GeneratedImageToolResult
    if (!imageResult.generated_image) {
      return
    }
    context.aiFacade.dispatch(
      AiActions.saveGeneratedImage({
        generatedImageUUID: imageResult.generated_image,
        onSuccess: () => {
          context.aiFacade.dispatch(SelectedAuctionActions.syncAuction({ showLoader: true }))
        },
      }),
    )
  }
}
